<div class="modal-header">
  <div class="content">
    <ng-content></ng-content>
  </div>
  <app-button Variant="cancel" class="close-button" (click)="OnHeaderCloseButtonClick()">
    <i class="bi bi-x-lg"></i>
  </app-button>
</div>